'use client';

import { useAuth } from '@/context/AuthContext';

import { LLMSettings } from '../../settings/components/LLMSettings';

export default function LLMPage() {
    const { user } = useAuth();

    if (!user) {
        return null;
    }

    return (

        <div className="min-h-screen bg-gray-50 py-8">
            <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="bg-white shadow rounded-lg">
                    <div className="px-4 py-5 sm:px-6">
                        <LLMSettings />
                    </div>
                </div>
            </div>
        </div>

    );
}
